import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectWisePodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetConnectwisePodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getConnectWisePodDataByContactId',
  async ({ psaId, contactId }) => {
    const r = await getConnectWisePodDataByContactId(psaId, contactId);
    return r.data;
  },
);
